(function initYoutubeFacade() {
  const YT_URL_REGEX = /(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|v\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/;
  function extractVideoId(input) {
    if (!input) return null;
    const value = input.trim();
    if (/^[A-Za-z0-9_-]{11}$/.test(value)) {
      return value;
    }
    const match = value.match(YT_URL_REGEX);
    return match ? match[1] : null;
  }
  function getPosterUrl(videoId, customPoster) {
    if (customPoster) return customPoster;
    return `https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg`;
  }
  function buildIframe(videoId, options) {
    const params = new URLSearchParams({
      autoplay: '1',
      rel: '0',
      modestbranding: '1',
      playsinline: '1',
    });
    if (options.start) params.set('start', options.start);
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.youtube-nocookie.com/embed/${videoId}?${params.toString()}`;
    iframe.title = options.title || 'YouTube video player';
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute(
      'allow',
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
    );
    iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    iframe.setAttribute('allowfullscreen', '');
    iframe.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:0;';
    return iframe;
  }
  function setupFacade(el) {
    const videoId = extractVideoId(el.dataset.video);
    if (!videoId) {
      console.warn('[yt-facade] data-video inválido em', el);
      return;
    }
    const posterUrl = getPosterUrl(videoId, el.dataset.poster);
    el.style.backgroundImage = `url('${posterUrl}')`;
    if (!el.dataset.poster) {
      const img = new Image();
      img.onerror = () => {
        el.style.backgroundImage = `url('https://i.ytimg.com/vi/${videoId}/hqdefault.jpg')`;
      };
      img.src = posterUrl;
    }
    el.addEventListener(
      'click',
      function handleClick() {
        const iframe = buildIframe(videoId, {
          start: el.dataset.start,
          title: el.dataset.title,
        });
        el.innerHTML = '';
        el.appendChild(iframe);
        el.classList.add('yt-facade--playing');
      },
      { once: true }
    );
  }
  document.querySelectorAll('.yt-facade').forEach(setupFacade);
})();